export enum TRouteName {
  Home = 'Home',
}
